import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomerFilters, CustomerQueryParams } from '../customer.model';

@Component({
    selector: 'ifb-customer-list-filter-dialog',
    templateUrl: './customer-list-filter-dialog.component.html',
    standalone: false
})
export class CustomerListFilterDialogComponent {
  form: UntypedFormGroup;
  filters: CustomerFilters;

  constructor(public dialogRef: MatDialogRef<CustomerListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.filters = new CustomerFilters(data.query);
    this.form = this.formBuilder.group({
      email: this.data.query.email || '',
      firstName: this.data.query.firstName || '',
      lastName: this.data.query.lastName || '',
      loanNumber: this.data.query.loanNumber || '',
      businessName: this.data.query.businessName || '',
      active: this.data.query.active || undefined,
      ssn: this.data.query.ssn || '',
    });
  }

  static show(dialog: MatDialog, query: CustomerQueryParams): Observable<any> {
    return dialog.open(CustomerListFilterDialogComponent, {
      data: { query },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new CustomerFilters(formValues));
  }
}
